import { Stack, Text } from '@mantine/core';

export const CompanyContactOption: React.FC<{ label: string }> = ({
  label,
}) => {
  const splittedOption = label.split(' | ');

  return (
    <Stack gap={0}>
      <Text size="sm">{splittedOption[0]}</Text>
      <Text size="xs" opacity={0.5}>
        {splittedOption[1]}
      </Text>
    </Stack>
  );
};
